import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { CoreModule } from '../core/core.module';
import { BillingModule } from './billing/billing.module';
import { BulkTaxReportModule } from './bulk-tax-report/bulk-tax-report.module';
import { CustomerRequestModule } from './customer-request/customer-request.module';
import { CustomerModule } from './customer/customer.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { DocumentRequestModule } from './document-request/document-request.module';
import { DocumentModule } from './document/document.module';
import { DownloadLogModule } from './download-log/download-log.module';
import { EmailDashboardModule } from './email-dashboard/email-dashboard.module';
import { HistoryLogModule } from './history-log/history-log.module';
import { ImportDataModule } from './import-data/import-data.module';
import { ProfileModule } from './profile/profile.module';
import { RDSendReportModule } from './rd-send-report/rd-send-report.module';
import { ReportModule } from './report/report.module';
import { SaleTaxModule } from './saletax/saletax.module';
import { SearchModule } from './search/search.module';
import { SellerModule } from './seller/seller.module';
import { SettingsModule } from './settings/settings.module';
import { SubmitToRdModule } from './submit-to-rd/submit-to-rd.module';
import { TaxB2PModule } from './tax-b2p/tax-b2p.module';
import { TaxReportModule } from './tax-report/tax-report.module';
import { ZipFileModule } from './zip-file/zip-file.module';


@NgModule({
  imports: [
    CommonModule,
    DocumentModule,
    ReportModule,
    SearchModule,
    DashboardModule,
    BillingModule,
    SaleTaxModule,
    ProfileModule,
    TaxReportModule,
    ZipFileModule,
    SubmitToRdModule,
    SettingsModule,
    TaxB2PModule,
    BulkTaxReportModule,
    EmailDashboardModule,
    ImportDataModule,
    CoreModule,
    FormsModule,
    DropdownModule,
    CheckboxModule,
    CustomerModule,
    SellerModule,
    RDSendReportModule,
    HistoryLogModule,
    CustomerRequestModule,
    DocumentRequestModule,
    DownloadLogModule,
  ],
  declarations: []
})
export class FeaturesModule {}



// WEBPACK FOOTER //
// /opt/app/src/app/features/features.module.ts